import { html } from '@design.estate/dees-element';
import { demoPage, demoOutput, showDemoResult } from '../../../demos/templates.js';

const logResponse = (event: CustomEvent) => {
  const card = event.target as HTMLElementTagNameMap['dees-harness-permission-card'];
  card.request = { ...card.request, response: event.detail.response, respondedAt: Date.now() };
  showDemoResult(event.currentTarget as Element, event.detail);
};

export const demoFunc = () => demoPage('Permissions', 'Review the requested action and choose how to proceed.', html`
  <div class="permissionDemo dees-demo-stack" @harness-permission-response=${logResponse}>
    <dees-harness-permission-card
      .request=${{
        id: 'p1',
        title: 'Run shell command',
        type: 'shell',
        createdAt: Date.now(),
        metadata: { command: 'rm -rf node_modules && pnpm install', cwd: '/srv/app' },
      }}
    ></dees-harness-permission-card>
    <dees-harness-permission-card
      .request=${{
        id: 'p2',
        title: 'Write file',
        type: 'write',
        metadata: { path: '/srv/app/src/config.ts', bytes: 812 },
      }}
    ></dees-harness-permission-card>
    <dees-harness-permission-card
      busy
      .request=${{
        id: 'p3',
        title: 'Navigate browser',
        type: 'browser',
        metadata: { action: 'navigate', url: 'https://admin.example.com' },
      }}
    ></dees-harness-permission-card>
    ${demoOutput()}
  </div>
`);
